import React from "react";
import { CustomButton } from "src/app/components";

type IProps = {
  applyEngageFilters: () => void
}

const FilterFooter: React.FC<IProps> = ({applyEngageFilters}) => {
  return (
    <CustomButton text="Apply Filters" color="primary" onClick={applyEngageFilters} />
  );
};

export default FilterFooter;
